/**
 * Smooth-scroll to an in-page section, falling back to an instant jump
 * when the visitor prefers reduced motion. Shared by the landing page
 * (header/hero CTAs) and the site footer (key links).
 *
 * Returns `true` when the section exists on the current view (and was
 * scrolled to), `false` otherwise — callers can fall back to a normal
 * navigation when the anchor lives on another view.
 */
export function scrollToSection(id: string): boolean {
  const el = document.getElementById(id);
  if (!el) return false;
  const reduceMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  return true;
}
